import { render, staticRenderFns } from "./spbcnWinnerCamp.vue?vue&type=template&id=eb4951a4&scoped=true&"
import script from "./spbcnWinnerCamp.vue?vue&type=script&lang=js&"
export * from "./spbcnWinnerCamp.vue?vue&type=script&lang=js&"
import style0 from "./spbcnWinnerCamp.vue?vue&type=style&index=0&id=eb4951a4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb4951a4",
  null
  
)

export default component.exports